import React from "react";
const Kcb = () => {
    return <div>
        <img src="/images/loadingGear.svg" />        
    </div>
}
export default Kcb;